module.exports = __webpack_public_path__ + "static/media/dots.4e0e8fc1.svg";